import { ExternalLink } from "lucide-react";

interface RockingLobsterLinkProps {
  testId: string;
}

export function RockingLobsterLink({ testId }: RockingLobsterLinkProps) {
  return (
    <a
      href="https://therockinglobster.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="rocking-lobster-link group flex items-center gap-2 text-xs text-slate-400 hover:text-white transition-colors duration-300"
      data-testid={testId}
    >
      <span className="rocking-lobster-text">
        Built by{" "}
        <span className="font-semibold text-amber-400 group-hover:text-amber-300">
          The Rocking Lobster Labs
        </span>
      </span>
      <ExternalLink
        className="w-3 h-3 opacity-50 group-hover:opacity-100 transition-opacity"
        aria-hidden="true"
      />
    </a>
  );
}
